import type { DeviceType } from '@/graphql/generated/schemas'

export const USERS_ACCESS_ROLES = [
  'IMPLEMENTER',
  'TECHNICIAN',
  'EMPLOYEE',
  'GUARD',
  'OPERATOR',
  'PROGRAM_MANAGER',
  'READ_ONLY_USER',
] as const

export type UsersAccessRole = (typeof USERS_ACCESS_ROLES)[number]

export const USERS_ACCESS_ACCOUNT_STATES = [
  'ACTIVE',
  'INVITED',
  'INVITE_EXPIRED',
] as const

export type UsersAccessAccountState =
  (typeof USERS_ACCESS_ACCOUNT_STATES)[number]

export const USERS_ACCESS_ACCOUNT_TYPES = [
  'USER',
  'TECHNICIAN',
  'PENDING_INVITE',
] as const

export type UsersAccessAccountType = (typeof USERS_ACCESS_ACCOUNT_TYPES)[number]

interface UsersAccessRowBaseI {
  key: string
  id: string
  email: string
  firstName: string
  lastName: string
  fullName: string
  roles: UsersAccessRole[]
  accountState: UsersAccessAccountState | null
  accountType: UsersAccessAccountType
}

export interface UsersAccessUserRowI extends UsersAccessRowBaseI {
  kind: 'user'
  roleName: string | null
  accountState: 'ACTIVE'
  accountType: 'USER'
}

export interface UsersAccessTechnicianRowI extends UsersAccessRowBaseI {
  kind: 'technician'
  accountState: null
  accountType: 'TECHNICIAN'
  deviceTypes: Array<DeviceType | null>
}

export interface UsersAccessPendingInviteRowI extends UsersAccessRowBaseI {
  kind: 'pending-invite'
  accountState: 'INVITED' | 'INVITE_EXPIRED'
  accountType: 'PENDING_INVITE'
  invitedAt: string
  lastInviteSentAt: string | null
}

export type UsersAccessRow =
  | UsersAccessUserRowI
  | UsersAccessTechnicianRowI
  | UsersAccessPendingInviteRowI

export interface UsersAccessFilterValuesI {
  roles: UsersAccessRole[]
  accountStates: UsersAccessAccountState[]
  accountTypes: UsersAccessAccountType[]
}

export interface UsersAccessFilterCountsI {
  roles: Record<UsersAccessRole, number>
  accountStates: Record<UsersAccessAccountState, number>
  accountTypes: Record<UsersAccessAccountType, number>
}

export interface UsersAccessTechnicianFormValuesI {
  deviceTypes: DeviceType[]
  email: string
  facilityIds: string[]
  firstName: string
  lastName: string
}

export type UsersAccessTechnicianFormErrors = Partial<
  Record<keyof UsersAccessTechnicianFormValuesI, string>
>
